import React, { useEffect, useState } from "react";
import styled from "styled-components"
import { Link } from "react-router-dom";
import { isMobile } from 'react-device-detect';

import { getAllShows } from "../shows"

const Shows = styled.div`
    margin: 25px 0px;
    max-width: 100vw;
    overflow: auto;
    padding-bottom: 25px;
    
    table {
        margin: 0px auto;
        
        tr {
            display: ${isMobile ? "block":"table-row"};
        }
        td {
            display: ${isMobile ? "flex":"table-cell"};
            align-items: center;

            img {
                display: block;
                width: 100%;
                width: 110px;
                height: ${isMobile ? "auto":"135px"};
            }

            a {
                flex-basis: 50%;
                text-decoration: none;
                color: white;
                display: block;
                text-align: center;

                &:hover {
                    text-decoration: underline;
                }

                div {
                    padding: 55px 10px;
                    height: 155px;
                    width: 100%;
                }
            }
            a.info {
                background-color: black;
                padding: 5px;
            }
        }
    }
`
const Heading = styled.h3`
    margin-bottom: 5px;
    text-align: center;
`

function ShowsListing(props) {
  const [shows, setShows] = useState(props.shows || getAllShows());

  return (
    <>
        <Heading>{props.heading || "2022-2023 Season"}</Heading>
        <Shows>    
            <table>
            <tbody>
            <tr>
            {shows.map((show, index) => (
                <td key={index}>
                    <Link to={show.url}>
                        {(show.festival && !show.poster) ? 
                            <div style={{backgroundColor: show.backgroundColor ? show.backgroundColor : "inherit"}}>
                                {show.title}
                            </div>
                        : 
                            <img src={show.poster} alt={show.title + " Poster"} width={100} />
                        }
                    </Link>
                    <Link to={show.url} className="info">
                        {show.dateFormattedShort}        
                    </Link>                       
                </td>
            ))} 
            </tr>   
            </tbody> 
            </table>          
        </Shows>
    </>
  );
}

export default ShowsListing;